import { LeftMenuItemKey } from "@/model/Application/LeftMenuItem";

export class NavElement {
  Id: LeftMenuItemKey;
  ClassName: string;
  Title: string;
  TranslationKey: string;
  Url: string;
  SvgIcon: any;
  HasGroupAccessControl?: boolean;
  AcceptedGroups?: Array<number>;
  IsAdminProtected: boolean = false;

  constructor(base: any) {
    Object.assign(this, base);
  }
}
